import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {
  // Logout after 7 minutes of inactivity
  private timeoutDuration = 7 * 60 * 1000;

  // Show warning after 6 minutes of inactivity
  private warningDuration = 6 * 60 * 1000;

  private inactivityTimer: any;
  private warningTimer: any;
  private active = false;

  constructor(
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) {}

  /**
   * Call this after successful login
   */
  public startWatcher(): void {
    if (this.active) return;

    this.active = true;

    ['click', 'mousemove', 'keypress', 'scroll'].forEach(event => {
      window.addEventListener(event, () => this.resetTimers());
    });

    this.resetTimers();
  }

  /**
   * Reset warning and logout timers
   */
  private resetTimers(): void {
    if (!this.active) return;

    clearTimeout(this.warningTimer);
    clearTimeout(this.inactivityTimer);

    // Show warning after 6 minutes
    this.warningTimer = setTimeout(() => {
      this.showWarning();
    }, this.warningDuration);

    // Logout after 7 minutes
    this.inactivityTimer = setTimeout(() => {
      this.logout();
    }, this.timeoutDuration);
  }

  /**
   * Show warning popup 1 minute before logout
   */
  private showWarning(): void {
    console.log('Warning shown at:', new Date());

    Swal.fire({
      title: 'Session Expiring Soon',
      text: 'You will be logged out in 1 minute due to inactivity.',
      icon: 'warning',
      timer: 60000,
      timerProgressBar: true,
      showConfirmButton: false
    });
  }

  /**
   * Logout user
   */
  private logout(): void {
    console.log('Logged out at:', new Date());

    this.active = false;

    clearTimeout(this.warningTimer);
    clearTimeout(this.inactivityTimer);

    this.storage.clear();

    Swal.fire({
      title: 'Session Expired',
      text: 'You have been logged out due to inactivity.',
      icon: 'info',
      timer: 2000,
      showConfirmButton: false
    }).then(() => {
      this.router.navigate(['/']); // Redirect to login page
    });
  }
}